import { containers } from './constants';
export const containerResize = () => {
  const $container = document.querySelector('.container');
  const containerObserver = new ResizeObserver(entries => {
    entries.forEach(entry => {
      const width = entry.target.clientWidth;
      const size = Object.keys(containers).find(key => containers[key] === width) || 'xs';
      const containerResizeEvent = new CustomEvent('containerResize', {
        detail: {
          size
        }
      });
      document.dispatchEvent(containerResizeEvent);
    });
  });
  containerObserver.observe($container);
};
export default containerResize;